import React from 'react';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import LockIcon from '@mui/icons-material/Lock';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';

const menus = [
  {
    label: ' ',
    type: 'section',
    children: [
      {
        uri: '/users',
        label: 'Users',
        type: 'nav-item',
        icon: <SupervisedUserCircleIcon sx={{ fontSize: 20 }} />,
        isActiveUri: ["/users"],
        permission: "user-list"
      },
      {
        uri: '/roles',
        label: 'Roles & Permissions',
        type: 'nav-item',
        icon: <LockIcon sx={{ fontSize: 20 }} />,
        isActiveUri: ["/roles"],
        permission: "role-list"
      },
      {
        uri: '/manage-dictionary',
        label: 'Manage Dictionary',
        type: 'nav-item',
        icon: <LocalLibraryIcon sx={{ fontSize: 20 }} />,
        isActiveUri: ["/manage-dictionary"],
        permission: "manage-dictionary"
      },
      {
        uri: '/',
        label: 'Spelling Checker',
        type: 'nav-item',
        icon: <SpellcheckIcon sx={{ fontSize: 20 }} />,
        isActiveUri: ["/"],
      },
    ],
  },
];

export default menus;
